'use es6';
/*
 * Specific to USER + PORTAL attributes.
 * Value will be hyphen-cased to API and localStorage slugs.
 *
 * https://git.hubteam.com/HubSpot/DesignManagerApi/pull/1035
 */

export const DESIGN_MANAGER_TABS = 'DESIGN_MANAGER_TABS';
export const CODEMIRROR_SESSION = 'CODEMIRROR_SESSION';
export const PREVIEW_OPTIONS = 'PREVIEW_OPTIONS';
export const LAYOUT_EDITOR_OPTIONS = 'LAYOUT_EDITOR_OPTIONS';
export const FINDER_OPTIONS = 'FINDER_OPTIONS';
export const FINDER_FOLDERS = 'FINDER_FOLDERS';
export const CUSTOM_MODULE_EDITOR_OPTIONS = 'CUSTOM_MODULE_EDITOR_OPTIONS';
export const GETTING_STARTED_TAB = 'GETTING_STARTED_TAB';